import httpService from "../../Service/httpService";

const controller = "SesionHemodialisis";


//LISTA DE PACIENTES CON CITA POR FECHA Y HORA
export const getPacientesProg = async (id, fecha, hora) => {
	const res = await httpService.get(`/${controller}/getPacientesProg/${id}/${fecha}/${hora}`);
	return res.data;
};

//LISTA DE PACIENTES CON CITA POR FECHA Y HORA
export const getHorariosAgenda = async (id, fecha) => {
	const res = await httpService.get(`/${controller}/getHorariosAgenda/${id}/${fecha}`);
	return res.data;
};


export const getLugarSesion = async (id, fecha, hora, idPac) => {
	const res = await httpService.get(`/${controller}/getLugarSesion/${id}/${fecha}/${hora}/${idPac}`);
	return res.data;
};

export const getListaAsistencia = async (id, fecha, hora) => {
	const res = await httpService.get(`/${controller}/getListaAsistencia/${id}/${fecha}/${hora}`);
	return res.data;
};

export const getListaAsistenciaTurno = async (id, fecha, idTurno) => {
	const res = await httpService.get(`/${controller}/getListaAsistenciaTurno/${id}/${fecha}/${idTurno}`);
	return res.data;
};

export const getTurnos = async (id) => {
	const res = await httpService.get(`/${controller}/getTurnos/${id}`);
	return res.data;
};

export const getFiltroAsignado = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getFiltroAsignado/${id}/${idPac}`);
	return res.data;
};

export const getHorariosTurno = async (id, idTurno) => {
	const res = await httpService.get(`/${controller}/getHorariosTurno/${id}/${idTurno}`);
	return res.data;
};


export const getInsumos = async (id) => {
	const res = await httpService.get(`/${controller}/getInsumos/${id}`);
	return res.data;
};

export const getStockInsumo= async (id, idInsumo, idEntrada) => {
	const res = await httpService.get(`/${controller}/getStockInsumo/${id}/${idInsumo}/${idEntrada}`);
	return res.data;
};

export const getInventarioInsumos = async (id) => {
	const res = await httpService.get(`/${controller}/getInventarioInsumos/${id}`);
	return res.data;
};

export const getInsumosSesion = async (id, idSesion) => {
	const res = await httpService.get(`/${controller}/getInsumosSesion/${id}/${idSesion}`);
	return res.data;
};

export const getEnfermeras = async (id) => {
	const res = await httpService.get(`/${controller}/getEnfermeras/${id}`);
	return res.data;
};

export const getMaquinas = async (id, usoPositivo) => {
	const res = await httpService.get(`/${controller}/getMaquinas/${id}/${usoPositivo}`);
	return res.data;
};


export const saveAsignacion = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveAsignacion`, {
		...data,
	});
	return res;
};

export const saveInsumo = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveInsumo`, {
		...data,
	});
	return res;
};

export const saveEntradaInsumo = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveEntradaInsumo`, {
		...data,
	});
	return res;
};

export const addInsumoSesion = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/addInsumoSesion`, {
		...data,
	});
	return res;
};

export const deleteInsumo = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/deleteInsumo`, {
		...data,
	});
	return res;
};


export const asignaLugar = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/asignaLugarHemo`, {
		...data,
	});
	return res;
};


